export enum SetupIntentType {
  Card = "card",
  IDeal = "ideal",
  OBT = "obt"
}
